// VideoIntro.js
import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Markdown from './Markdown';

// Keeps existing constants for compatibility
const imageStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  border: 0
};

const iframeStyleDefault = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 0
};

const VideoIntroLanding = ({ section }) => {


  const {
    useImageUnderlay = false,
    yt_url = `https://www.youtube.com/embed/gqGCei_DePA?autoplay=1&mute=1&loop=1&controls=0&playlist=gqGCei_DePA&modestbranding=1&playsinline=1&rel=0`,
    img_path = '/ai_banner.png',
    hero_button_label = 'courses',
    hero_button_link = 'http://google.com',
    hero_area_text = 'sign up\n\n\n\n\n\n\n\n',
    call_to_action_title = 'LEARN \nAI\n ART\n',
    iframeStyle
  } = section || {};

  // New layout styles
  const sectionStyle = { position: 'relative', width: '100%' };
  const videoWrapResponsive = {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%', // 16:9
    overflow: 'hidden',
    borderRadius: '0.5rem',
    boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)',
    backgroundColor: '#000'
  };
  //const iframeStyleMergedfdfd = iframeStyle || iframeStyleDefault;
  const titleStyle = {
    fontWeight: 800,
    whiteSpace: 'pre-line',
    lineHeight: 1.05,
    fontSize: 'clamp(2rem, 6vw, 4rem)'
  };

  return (
    <section style={sectionStyle}>
      <Container className="py-5">
        <Row className="g-4 align-items-start">
          {/* LEFT: title + video */}
          <Col md={7}>
            <h1 style={titleStyle}>{call_to_action_title}</h1>
            <Markdown md={hero_area_text} />
          </Col>

          {/* RIGHT: content box + CTA (stacks below on mobile) */}
          <Col md={5}>
            <Card className="shadow-lg h-100">
              <Card.Body className="d-flex flex-column">
            <div style={videoWrapResponsive} className="mt-3">
              {useImageUnderlay ? (
                <img src={img_path} alt="" style={imageStyle} />
              ) : (
                <iframe
                  title="Video"
                  src={yt_url}
                  style={iframeStyleDefault}
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
                
                <div className="mt-4">
                  <Button
                    variant="danger"
                    size="lg"
                    href={hero_button_link}
                    style={{
                      fontSize: '1.25rem',
                      padding: '0.85rem 1.75rem',
                      backgroundColor: 'darkred',
                      borderColor: 'black'
                    }}
                  >
                    {hero_button_label}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Keep legacy anchor for compatibility */}
      <div id="video-intro-bottom" />
    </section>
  );
};

export default VideoIntroLanding;
